import { createContext } from "react";

export interface INetworkSystemCtx {
  sessionId?: string;
  isConnected: boolean;
  send: (event: string, msg: any) => void;
}

export const NetworkSystemCtx = createContext<INetworkSystemCtx | null>(null);
